import { CATEGORIES } from "../../data/content";
import { Reveal } from "./Reveal";
import { SectionEyebrow } from "./About";

export const Categories = () => {
  return (
    <section
      id="expertise"
      data-testid="categories"
      className="relative grain border-t px-6 py-28 lg:px-10 lg:py-36"
      style={{ borderColor: "var(--border)" }}
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 items-end gap-8 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <Reveal>
              <SectionEyebrow index="02">Expertise</SectionEyebrow>
              <h2 className="font-head mt-6 max-w-3xl text-4xl leading-tight text-[color:var(--text)] sm:text-5xl">
                Every category of luxury, held to a single standard.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4">
            <Reveal delay={0.1}>
              <p className="text-[15px] leading-relaxed text-[color:var(--text-2)]">
                Deep, category-specific knowledge across the full spectrum of the
                luxury and resale markets — built over two decades and a billion
                dollars in goods.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CATEGORIES.map((c, i) => (
            <Reveal key={c.title} delay={(i % 3) * 0.08}>
              <div
                className="group relative overflow-hidden border"
                style={{ borderColor: "var(--border)", borderRadius: "var(--radius-tok)" }}
              >
                <div className="overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.title}
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div
                  aria-hidden
                  className="pointer-events-none absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, transparent 40%, rgba(10,10,10,0.92) 100%)",
                  }}
                />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <h3 className="font-head text-2xl text-[color:var(--text)]">{c.title}</h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-[color:var(--text-2)] opacity-0 transition-all duration-500 group-hover:opacity-100">
                    {c.desc}
                  </p>
                </div>
                <span
                  className="absolute right-5 top-5 h-8 w-8 -translate-y-1 border opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100"
                  style={{ borderColor: "var(--accent)" }}
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
